import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";

const AddState = () => {
  const [stateName, setStateName] = useState("");
  const [countryId, setCountryId] = useState("");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  // Fetch all countries
  const fetchCountries = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllCountries`);
      setCountries(response.data.countries);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  // Fetch all states
  const fetchStates = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllStates`);
      setStates(response.data.states);
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  // Fetch countries and states on component mount
  useEffect(() => {
    fetchCountries();
    fetchStates();
  }, []);

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!countryId) {
      Swal.fire("Validation Error", "Please select a country", "warning");
      return;
    }

    if (!stateName.trim()) {
      Swal.fire("Validation Error", "State name is required", "warning");
      return;
    }

    console.log("Sending Data:", { state_name: stateName, country_id: countryId });

    try {
      await axios.post(`${baseurl}addState`, {
        state_name: stateName,
        country_id: countryId,
      });

      Swal.fire("Success", "State added successfully!", "success").then(() => {
        setStateName("");
        setCountryId("");
        fetchStates(); // Refresh the state list
      });
    } catch (error) {
      console.error("Error adding state:", error);
      Swal.fire("Error", "Failed to add state. Try again!", "error");
    }
  };

  // Define table columns
  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true },
    { name: "State Name", selector: (row) => row.state_name, sortable: true },
    { name: "Country Name", selector: (row) => row.country_name, sortable: true },
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />

        <div className="container-fluid">
          <h4 className="mb-3 text-start">Add State</h4>
          <div className="crd1 mb-3">
            <div className="row">
              {/* Form to Add State */}
              <form onSubmit={handleSubmit}>
                <div className="row mb-3 align-items-end">
                  {/* Country Dropdown */}
                  <div className="col-md-5">
                    <select
                      className="form-control"
                      value={countryId}
                      onChange={(e) => setCountryId(e.target.value)}
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.country_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* State Input */}
                  <div className="col-md-5">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter State Name"
                      value={stateName}
                      onChange={(e) => setStateName(e.target.value)}
                    />
                  </div>

                  {/* Submit Button */}
                  <div className="col-md-2 d-flex">
                    <button type="submit" className="btn btn-primary mt-auto">
                      Add State
                    </button>
                  </div>
                </div>
              </form>

              {/* State List Table */}
              <div className="mt-4">
                <DataTable columns={columns} data={states} pagination highlightOnHover />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddState;
